var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 315,
    viewBox: "0 0 654 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_5003_17964)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.418,
    cy: 157.5,
    rx: 112.5,
    ry: 48.5,
    fill: "#B9D5FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.95 188.424L448.696 155.718L579.091 39.6424L627.663 51.1451L595.554 186.728L621.777 192.938L613.186 229.213L586.964 223.003L576.965 265.224L535.247 255.344L545.245 213.123L440.95 188.424ZM578.064 86.5004L495.431 163.017L556.518 177.484L578.064 86.5004Z",
    fill: "#F2F9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3429 197.371L10.8036 175.826L64.0515 76.6111L95.9793 72.8481L106.506 162.163L123.743 160.132L126.559 184.027L109.322 186.059L112.6 213.872L85.1776 217.104L81.8996 189.291L13.3429 197.371ZM73.7822 105.252L40.6915 169.92L80.8461 165.188L73.7822 105.252Z",
    fill: "#F2F9F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.919 103C232.778 103 180.918 155.579 180.918 220.611H412.919C412.919 155.579 360.719 103 296.919 103Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.447 166.523V157.876H224.588V149.573L234.141 144.039V157.876H240.624V166.523H234.141V177.939C234.141 180.706 234.483 182.436 235.165 183.127C235.847 183.819 237.894 184.165 240.624 184.165V193.505H239.259C233.8 193.505 229.706 192.467 227.659 190.046C225.612 187.624 224.247 183.819 224.247 177.939V166.523H218.447Z",
    fill: "#1264E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.06 188.66C270.648 192.119 266.212 194.195 261.095 194.195C255.977 194.195 251.542 192.465 248.13 188.66C244.719 185.201 242.671 180.704 242.671 175.515C242.671 170.326 244.377 165.83 248.13 162.37C251.542 158.912 255.977 156.836 261.095 156.836C266.212 156.836 270.648 158.565 274.06 162.37C277.471 165.83 279.519 170.326 279.519 175.515C279.519 180.704 277.812 185.201 274.06 188.66ZM261.095 184.856C263.483 184.856 265.53 183.818 267.236 182.089C268.942 180.359 269.965 177.937 269.965 175.516C269.965 173.095 268.942 170.674 267.236 168.944C265.53 167.214 263.483 166.176 261.095 166.176C258.706 166.176 256.659 167.214 254.954 168.944C253.248 170.674 252.565 173.095 252.565 175.516C252.565 177.937 253.248 180.359 254.954 182.089C256.659 183.818 258.706 184.856 261.095 184.856Z",
    fill: "#1264E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.741 194.195C298.965 194.195 295.553 192.811 293.165 190.044V210.107H283.271V157.528H292.824V161.679C295.553 158.565 298.965 156.836 303.401 156.836C305.448 156.836 307.495 157.182 309.542 157.874C311.589 158.565 313.295 159.603 315.001 161.333C316.706 162.717 318.071 164.792 319.095 167.213C320.118 169.635 320.459 172.402 320.459 175.515C320.459 181.396 318.753 185.893 315.001 189.352C311.93 192.465 308.177 194.195 303.741 194.195ZM301.695 185.2C304.424 185.2 306.471 184.163 308.518 182.433C310.224 180.704 311.248 178.282 311.248 175.515C311.248 172.747 310.224 170.326 308.518 168.597C306.812 166.867 304.424 165.829 301.695 165.829C298.965 165.829 296.918 166.867 295.212 168.597C293.506 170.326 292.483 172.747 292.483 175.515C292.483 178.282 293.506 180.358 295.212 182.433C296.918 184.163 299.306 185.2 301.695 185.2Z",
    fill: "#1264E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.213 193.503V157.527H333.766V193.503H324.213Z",
    fill: "#1264E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.918 194.195C350.824 194.195 346.73 192.465 343.318 189.352C339.907 185.893 337.859 181.396 337.859 175.515C337.859 171.364 338.883 167.905 340.589 165.138C342.295 162.37 344.683 160.295 347.071 158.912C349.459 157.528 352.189 156.836 354.918 156.836C359.354 156.836 362.766 158.22 365.495 160.987V157.528H375.389V193.503H365.836V189.352C363.107 192.465 359.354 194.195 354.918 194.195ZM356.966 185.2C359.695 185.2 361.742 184.163 363.448 182.433C365.154 180.704 366.177 178.282 366.177 175.515C366.177 172.747 365.154 170.672 363.448 168.597C361.742 166.867 359.695 165.829 356.966 165.829C354.236 165.829 352.189 166.867 350.142 168.597C348.436 170.326 347.413 172.747 347.413 175.515C347.413 178.282 348.436 180.704 350.142 182.433C351.848 184.163 354.236 185.2 356.966 185.2Z",
    fill: "#1264E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.989 155.108C330.695 155.108 331.719 154.416 332.743 153.378C333.766 152.341 334.448 150.957 334.448 149.573C334.448 147.844 333.766 146.806 332.743 145.768C331.719 144.731 330.354 144.039 328.989 144.039C327.624 144.039 326.26 144.731 325.236 145.768C324.213 146.806 323.872 148.19 323.872 149.573C323.872 150.957 324.213 152.341 325.236 153.378C326.26 154.416 327.624 155.108 328.989 155.108Z",
    fill: "#1264E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5003_17964",
    x: 72.1872,
    y: 0.26873,
    width: 442.463,
    height: 314.463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 54.3656,
    result: "effect1_foregroundBlur_5003_17964"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404Error.04396df158fac93c20adc8723d70bf23.svg";
export { ForwardRef as ReactComponent };